import React, { Component } from 'react'

export default function FourOhFour(){

    return(<p>Nothing to see here</p>);
}